import { memo } from 'react';
import { cx } from '@emotion/css';

import cn from './styles.module.scss';

const Heading = ({ className = '', heading, children, styled = '' }) => {
    const Comp = heading;

    return <Comp className={cx(className, cn[styled || heading])}>
        {children}
    </Comp>;
};

export default memo(Heading);
